import React, { FC, memo } from "react";
import map from "lodash/map";
import { useTranslation } from "react-i18next";
import cn from "clsx";
import Img from "@/components/img";
import { useAppSelector } from "@/redux/store";
import "./paymentIcons.scss";

type Props = { footerWeb?: boolean };

const PaymentIcons: FC<Props> = ({ footerWeb }) => {
  const { t } = useTranslation("footer");
  const commonSettings = useAppSelector(
    state => state.common.configSettings.common
  );
  const weAcceptIcons = commonSettings?.weAcceptIcons
    ? JSON.parse(commonSettings.weAcceptIcons)
    : [];
  if (weAcceptIcons.length <= 0) return null;

  return (
    <>
      <div className={cn("we_accept", { we_accept_footer: footerWeb })}>
        {!footerWeb && <div className="title">{t("weAccept")}</div>}
        <div className="we-accept-payments">
          <ul>
            {map(weAcceptIcons, (options, index) => (
              <li key={index}>
                <Img src={options.image} alt="cardAccept" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default memo(PaymentIcons);
